import { Metamodel } from '../base/model';
import { ProvisioningState } from '../managedprivateendpoint/managedprivateenpoint-types';

/**
 * Kind of a share.
 */
export enum ShareKind {
    CopyBased,
    InPlace
}

/**
 * Args for share constructor
 * @param name The name of the azure resource.
 * @param subscriptionId The Azure subscription Id to which the azure resource belongs.
 * @param resourceGroup The Azure resource group to which the azure resource belongs.
 * @param description The share description.
 * @param terms The share terms.
 * @param createdAt The time at which the share was created.
 * @param createdBy The identity that created the share.
 * @param shareKind The type of the share.
 * @param provisioningState Gets or sets the provisioning state.
 */
export interface IDataShareArgs {
    readonly name: string;
    readonly subscriptionId: string;
    readonly resourceGroup: string;
    readonly id?: string;
    readonly location?: string;
    readonly description: string;
    readonly terms: string;
    readonly createdAt: Date;
    readonly userName?: string;
    readonly userEmail?: string;
    readonly shareKind: ShareKind;
    readonly provisioningState: ProvisioningState;
}

@Metamodel.model({
    name: 'DataShare'
})
export class DataShare {
    public readonly name: string;
    public readonly subscriptionId: string;
    public readonly resourceGroup: string;
    public readonly description: string;
    public readonly terms: string;
    public readonly createdAt: Date;
    public readonly shareKind: ShareKind;
    public readonly provisioningState: ProvisioningState;
    public readonly id?: string;
    // eslint-disable-next-line
    public readonly type = 'Microsoft.DataShare/shares';
    public readonly userName?: string;
    public readonly userEmail?: string;
    public readonly location?: string;

    public constructor(args: IDataShareArgs) {
        this.id = args.id;
        this.name = args.name;
        this.description = args.description;
        this.subscriptionId = args.subscriptionId;
        this.resourceGroup = args.resourceGroup;
        this.terms = args.terms;
        this.createdAt = args.createdAt;
        this.shareKind = args.shareKind;
        this.provisioningState = args.provisioningState;
        this.userEmail = args.userEmail;
        this.userName = args.userName;
        this.location = args.location;
    }

    public get createdBy(): string {
        return this.userName || this.userEmail || '';
    }
}
